<template>
  <b-container>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="danger" :msg="alert.error" />
    <div class="col-lg-4 col-md-6 ml-auto mr-auto">
      <h2>{{ $t("userProfile.changePassword") }}</h2>
      <div class="mt-2">
        <div>
          <b-form-group
            :label="$t('userProfile.newPassword')"
            label-for="newPassword"
          >
            <b-col style="padding-left: 0%">
              <b-form-input
                id="newPassword"
                type="password"
                :placeholder="$t('userProfile.newPassword')"
                v-model="model.newPassword"
              />
            </b-col>
            <span class="text-danger" v-if="modelstate['NewPassword']">
              {{ modelstate["NewPassword"][0] }}
            </span>
          </b-form-group>
        </div>
      </div>
      <b-form-group
        :label="$t('userProfile.passwordConfirmation')"
        label-for="passwordConfirmation"
      >
        <b-col style="padding-left: 0%">
          <b-form-input
            id="passwordConfirmation"
            type="password"
            :placeholder="$t('userProfile.passwordConfirmation')"
            v-model="model.passwordConfirmation"
          />
        </b-col>
        <span class="text-danger" v-if="modelstate['PasswordConfirmation']">
          {{ modelstate["PasswordConfirmation"][0] }}
        </span>
      </b-form-group>
      <b-row>
        <b-col sm="12" md="3">
          <b-button @click="save()"> Salvar </b-button>
        </b-col>
      </b-row>
    </div>
    <!-- <div>new: {{ model.newPassword }}</div> -->
    <!-- <div>confirmation: {{ model.passwordConfirmation }}</div> -->
  </b-container>
</template>
<script>
export default {
  name: "ChangePassword",
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
  },
  props: {
    userId: String,
  },
  data: function () {
    return {
      alert: {
        error: "Verifique os dados informados",
        success: "Senha alterada com sucesso",
      },

      model: {
        newPassword: "",
        passwordConfirmation: "",
      },
      modelstate: {},
    };
  },
  methods: {
    save() {
      this.$apiScheduler
        .post("/v1/user/resetPassword/" + this.userId, this.model)
        .then((response) => {
          console.log(response.data);
          let user = response.data;
          if (user == true) this.$router.push(`/login`);
          else this.$refs.danger.show();
        })
        .catch((error) => {
          console.log("error");
          console.log(error);
          this.modelstate = {};

          if (error.response) {
            console.log(error.response);
            if (error.response.status == 400) {
              this.modelstate = error.response.data.errors;
              // this.alert.error = error.message;
              this.$refs.danger.show();
            } else if (error.response.status == 500) {
              this.alert.error = error.response.data;
              this.$refs.danger.show();
            } else {
              this.alert.error = error.message;
              this.$refs.danger.show();
            }
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
  },
};
</script>
<style scoped>
.resetPasswor {
  text-align: center !important;
}
</style>